// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--W28kr","icon":"da51a739f7--icon--M5luq","label":"da51a739f7--label--LF0xM"};